// extracted by mini-css-extract-plugin
export var content = "styles-module--content--cb732";
export var dark = "styles-module--dark--e7c22";
export var light = "styles-module--light--0230c";
export var wrapper = "styles-module--wrapper--a3086";